"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFingerPrint = void 0;
var tslib_1 = require("tslib");
var fingerprintjs_1 = tslib_1.__importDefault(require("@fingerprintjs/fingerprintjs"));
// Initialize an agent at application startup.
var fpPromise = fingerprintjs_1.default.load({
    monitoring: false,
});
var getFingerPrint = function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var fp, result;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fpPromise];
            case 1:
                fp = _a.sent();
                return [4 /*yield*/, fp.get()];
            case 2:
                result = _a.sent();
                return [2 /*return*/, result.visitorId];
        }
    });
}); };
exports.getFingerPrint = getFingerPrint;
